import { useState } from 'react';
import { SCOPES } from '../../../../config/permissions-map';
import * as Utilities from '../../../../Components/Utils/Utils';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from '../../../../../_metronic/layout/core';
import PermissionsGate from '../../../../api/PermissionsGate';
import { Unauthorized } from '../../../Global/unauthorized';
import All_in from './All_in';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import DatePickerYear from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import SelectList from '../../../../Components/Select/SelectList';
import { useGetToken } from '../../../../Hooks/CustomHooks';
import * as Api from '../../../../api/Api';

function MapaVistaGeneral_all_in({ title }) {
    const lsUnidadEconomica = JSON.parse(sessionStorage.getItem("MapaAllIn"));
    const lsDateanio1 = sessionStorage.getItem("MapaAllIn_date_anio1");
    const lsDateanio2 = sessionStorage.getItem("MapaAllIn_date_anio2");
    const lsDatemes = sessionStorage.getItem("MapaAllIn_date_mes");

    const dYear = new Date();

    const [dateMes, setDateMes] = useState(new Date(dYear.getFullYear(), dYear.getMonth() - 1, dYear.getDate()));
    const [dateMesTemp, setDateMesTemp] = useState(new Date(dYear.getFullYear(), dYear.getMonth() - 1, dYear.getDate()));


    let dateFormated1 = (dateMes) ? dateMes.getFullYear() : dateMesTemp.getFullYear();

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();

    const [año2, setAño2] = useState(new Date(Utilities.getAnioComparativo(), month, day));
    let dateFormated2 = año2.getFullYear();

    let dateFormatedMes = (dateMes) ? ("0" + (dateMes.getMonth() + 1)).slice(-2) : ("0" + (dateMesTemp.getMonth() + 1)).slice(-2);

    registerLocale("es", es);

    const [unidadEconomica, setUnidadEconomica] = useState(
        lsUnidadEconomica != null ? lsUnidadEconomica : Utilities.getListUnidadesEconomicas().list[0]
    );
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();
    const getOptionUnidadEconomica = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }
    const onChangeUnidadEconomica = (inputValue) => {
        sessionStorage.setItem("MapaAllIn", JSON.stringify(inputValue));
        setUnidadEconomica(inputValue);
        // window.location.reload(false);
    }


    const token = useGetToken();

    const [categoria, setCategoria] = useState(null);
    const onChangeCategoria = (inputValue) => {
        setCategoria(inputValue);
    }



    const animatedComponents = makeAnimated();

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.MAPA_CALOR_ALL_IN]} >
                <>
                    <PageTitle>{title}</PageTitle>
                    <div className="card my-5">
                        <div className="card-header border-0 pt-6 row g-3 flex-wrap d-flex flex-row" style={{ zIndex: 10 }}>
                            <div className="col-12 col-sm-3">
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                                <Select
                                    classNamePrefix='filter'
                                    components={animatedComponents}
                                    defaultValue={lsUnidadEconomica != null ? lsUnidadEconomica : getOptionUnidadEconomica(unidadesEconomicasList.defaultId)}
                                    isMulti={false}
                                    closeMenuOnSelect={true}
                                    options={unidadesEconomicasList.list}
                                    onChange={(onChangeUnidadEconomica)}
                                />
                            </div>

                            <div className='col-12 col-sm-3'>
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Mes Cierre:</div>
                                <DatePickerYear
                                    className="form-control form-control-transparent pe-5"
                                    locale="es"
                                    selected={dateMes}
                                    onChange={(dateX) => {
                                        if (dateX) {
                                            setDateMes(dateX)
                                        }
                                    }}
                                    dateFormat="MM/yyyy"
                                    showMonthYearPicker
                                    maxDate={new Date()}
                                />
                            </div>

                            <div className='col-12 col-sm-3'>
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Año Comparativo:</div>
                                <DatePickerYear
                                    className="form-control form-control-transparent pe-5"
                                    locale="es"
                                    selected={año2}
                                    onChange={(dateX) => dateX && setAño2(dateX)}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    minDate={Utilities.add_years(new Date(), -6)}
                                    maxDate={new Date()}
                                />
                            </div>

                            <div className='col-12 col-sm-3' >
                                <SelectList
                                    title="Categoría"
                                    apiService={Api.MapaCalorAllIn_CategoryList}
                                    args={{ type: 'list', token: token }}
                                    conditions={true}
                                    handleChange={onChangeCategoria}
                                    multiple={false}
                                    defaultSetterFunction={setCategoria}
                                    addSelectAllOption={false}
                                />
                            </div>
                        </div>

                        <div className="card-body tab-content pt-0">
                            {categoria &&
                                <All_in
                                    unidadEconomicaId={unidadEconomica.value}
                                    unidadEconomicaName={unidadEconomica.label}
                                    anio1={dateFormated1}
                                    anio2={dateFormated2}
                                    mes={dateFormatedMes}
                                    categoria={categoria.value}
                                >
                                </All_in>}
                        </div>
                    </div>
                </>
            </PermissionsGate>
        </>
    )
}

export default MapaVistaGeneral_all_in
